import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { invalidateFor } from "@/lib/cache-registry";

/** VIB-2925: admin vedlikeholder fagfeltlista. Fagfelt slettes aldri, de deaktiveres (RLS: bare admin). */
export function useSaveFreelancerDiscipline() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { id?: string; label?: string; sort_order?: number; is_active?: boolean }) => {
      const { id, ...fields } = input;
      if (fields.label !== undefined) {
        fields.label = fields.label.trim();
        if (!fields.label) throw new Error("Navn mangler");
      }
      const { error } = id
        ? await supabase.from("freelancer_disciplines").update(fields).eq("id", id)
        : await supabase.from("freelancer_disciplines").insert(fields);
      if (error) throw error.code === "23505" ? new Error("Fagfeltet finnes allerede") : error;
    },
    onSuccess: async () => {
      await invalidateFor(qc, "freelancer_disciplines");
    },
    onError: (err: Error) => toast.error(`Kunne ikke lagre fagfeltet: ${err.message}`),
  });
}
